import { baseApi } from './base.api';
import { API_CONFIG } from '../config/api.config';

class SettingsService {
  getSettings() {
    return baseApi.get(API_CONFIG.ENDPOINTS.SETTINGS.GET);
  }

  updateSettings(data) {
    return baseApi.put(API_CONFIG.ENDPOINTS.SETTINGS.UPDATE, data);
  }
}

export const settingsService = new SettingsService();
